export class ZoomResetUtil {
    public resetZoom() {
        const viewportMeta = document.querySelector('meta[name="viewport"]');
        if (viewportMeta) {
            viewportMeta.setAttribute(
                'content',
                'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
            );

            setTimeout(() => {
                viewportMeta.setAttribute(
                    'content',
                    'width=device-width, initial-scale=1.0'
                );
            }, 300);
        }
    }
}

export default ZoomResetUtil;
